import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { RoleShared } from '@portal/models/roleShared';
import { PermissionsService } from './permissions.service';
import PrivilegesEnum = RoleShared.PrivilegesEnum;

@Directive({
  selector: '[portalCanAccess]',
  standalone: false,
})
export class CanAccessDirective implements OnInit {
  private readonly templateRef = inject<TemplateRef<any>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly permissionsService = inject(PermissionsService);

  @Input() portalCanAccess: PrivilegesEnum[];

  ngOnInit(): void {
    this.checkPermissions();
  }

  private checkPermissions(): void {
    const allowed = this.portalCanAccess.every(p => this.permissionsService.hasPermission(p));
    if (allowed) {
      this.viewContainer.createEmbeddedView(this.templateRef);

      return;
    }

    this.viewContainer.clear();
  }
}
